import { withLoyaltyStore } from "../../utils/withLoyaltyStore";

import { TrustedPlacesV2 as TrustedPlacesV2Base } from "./TrustedPlacesV2";

export type * from "./TrustedPlacesV2";
export const TrustedPlacesV2 = withLoyaltyStore(TrustedPlacesV2Base, "TrustedPlacesV2");
